<template>
  <div class="container" style="max-width: 72rem">
    <!-- <section class="my-6">
      <Education is_editable />
    </section>

    <section class="my-6">
      <Research is_editable />
    </section> -->

    <section class="my-6">
      <ProfileURL is_editable :profile_url="profile_url"/>
    </section>
    <section class="my-6">
      <Organization is_editable :organization_name="organization_name"/>
    </section>
    
    <section class="my-6 mentorship-areas">
      <MentorshipAreas is_editable @profile_url="profile_url_function"/>
    </section>
  </div>
</template>

<script>
import MentorshipAreas from '../../components/common/ExperienceMentor';
// import Education from '../../components/common/Education';
// import Research from '../../components/common/Research';
import ProfileURL from '../../components/common/ProfileURL.vue';

export default {
  components: {
    MentorshipAreas,   
    // Education,
    // Research,
    ProfileURL,
  },
  data() {
    return {
      profile_url: '',
    }
  },
  methods: {
    profile_url_function(profile_url){
      this.profile_url = profile_url
      console.log(this.profile_url)
    }
  }
};
</script>

<style scoped>
@media (min-width: 769px) {
  .vertical-divider {
    border-left: lightgray dashed 1px;
  }
}
</style>
